import { Component, OnInit } from '@angular/core';
import { FormFields } from '../../_models/forms/form-fields.interface';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CacheService } from 'src/app/_core/_services/cache.service';
import { PortalTransactionsService } from 'src/app/features/portal/_services/portal/portal-transactions.service';

@Component({
  selector: 'app-share-payment-dialog',
  templateUrl: './share-payment-dialog.component.html',
  styleUrls: ['./share-payment-dialog.component.scss']
})
export class SharePaymentDialogComponent implements OnInit {
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private cacheService: CacheService,
    private transactionsService: PortalTransactionsService
  ) {}

  paymentMethods = [
    { label: 'Credit/Debit Card', value: 'creditcard' },
    // { label: 'Cash', value: 'cash' },
    { label: 'EFT', value: 'eft' },
    { label: 'Capitec Pay', value: 'capitecpay' }
  ];

  payFormFields: FormFields[] = [
    {
      name: 'payment_method',
      label: 'Payment Method',
      description: 'Select the payment method you want to use',
      type: 'select',
      placeholder: 'Select Payment Method',
      valueOptions: this.paymentMethods,
      validators: { required: { required: true } },
      rendered: true
    },
    {
      name: 'save_payment_method',
      label: 'Save Payment Method',
      description:
        'Save this payment method for future use and allow future payments to be processed automatically',
      controlType: 'checkbox',
      value: false,
      validators: { required: { required: true } },
      rendered: true
    }
  ];

  ngOnInit(): void {
    // this.conf;
  }

  onPaymentLinkSubmit(paymentLinkDetails: any) {
    // Handle form submission logic here

    const portalUser = this.cacheService.getItem('portalUser');

    this.transactionsService
      .getPortalTransactionPayLink(
        this.config.data.transaction,
        portalUser && portalUser.portal_end_customer_id,
        paymentLinkDetails.payment_method
      )
      .subscribe((res) => {
        console.log('pay link: ', res);
        this.ref.close();
        if (res && res.paymentRedirect) {
          window.location.href = res.paymentRedirect;
        }
      });
  }

  closeDialog() {
    this.ref.close();
  }
}
